import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const medicalReportApi = createApi({
  reducerPath: "medicalReport",
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    // CREATE MEDICAL REPORT
    createMedicalReport: builder.mutation({
      query: (formData) => ({
        url: "users/medical-reports",
        method: "POST",
        body: formData,
      }),
    }),

    // GET LIST BY PATIENT
    getMedicalReports: builder.query({
      query: (patient_id) => `users/medical-reports?patient_id=${patient_id}`,
    }),

    // GET SINGLE REPORT
    getMedicalReportDetails: builder.query({
      query: (id) => `users/medical-reports/${id}`,
    }),
    // UPDATE REPORT
    updateMedicalReport: builder.mutation({
      query: ({ id, body }) => ({
        url: `users/medical-reports/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // DELETE REPORT
    deleteMedicalReport: builder.mutation({
      query: (id) => ({
        url: `users/medical-reports/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useCreateMedicalReportMutation,
  useGetMedicalReportsQuery,
  useDeleteMedicalReportMutation,
  useGetMedicalReportDetailsQuery,
  useUpdateMedicalReportMutation,
} = medicalReportApi;
